<script setup>

    import { watch, ref } from 'vue'
    import { util } from '@/Helpers'
    import { storeToRefs } from 'pinia'
    import { useElementHover } from '@vueuse/core'
    import { useCaregiverSingleStore } from '@/Stores'

    const caregiverSingleStore = useCaregiverSingleStore()
    const { userFocusedOn } = storeToRefs(caregiverSingleStore)

    const props = defineProps({
        isCurrentOrFutureWeek: {
            type: Boolean
        },
        block: {
            type: Object
        },
        size: {
            type: String
        },
        reasons: {
            type: Array,
            default: () =>[]
        }
    })

    const searchScheduleViewBlock = ref(null)
    const blockState = useElementHover(searchScheduleViewBlock, { delayEnter: 60, delayLeave: 60 })

    watch(blockState, (newValue, oldValue) => {
        if (blockState.value == true) {
            userFocusedOn.value = 'search'
        } else {
            userFocusedOn.value = null
        }
    }, { immediate: true })

</script>

<template>

    <div
        ref="searchScheduleViewBlock"
        :class="[
            'overflow-hidden text-lifeworx-blue-600',
            {
                'w-36': size == '2xl',
            }
        ]"
    >

        <div :class="[
            {
                'flex flex-col items-stretch space-y-0.5': size == 'xs',
                'absolute left-0.5 top-0 flex flex-col items-stretch space-y-0.5': size == 'sm' && isCurrentOrFutureWeek,
                'space-y-0.5': size == 'md' && isCurrentOrFutureWeek,
                'space-y-1': size == 'lg' && isCurrentOrFutureWeek,
                'space-y-1': size == 'xl' && isCurrentOrFutureWeek,
                'space-y-2': size == '2xl' && isCurrentOrFutureWeek,
                'relative h-full': !isCurrentOrFutureWeek,
            }
        ]">

            <!-- Time -->
            <div v-if="['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'].includes(size) && ((block.continuation && block.day_of_week == 'sunday') || (block.duration > block.total_duration - block.duration) || (block.duration >= block.total_duration - block.duration && block.continues))">
                <span
                    :class="[
                        'whitespace-nowrap font-bold',
                        {
                            'text-[0.75rem] font-bold my-0 -mt-1 leading-none inline-block scale-90': size == '2xs',
                            'text-xs font-bold my-0 leading-none': size == 'xs',
                            'text-sm font-bold my-0 leading-snug': size == 'sm',
                            'text-sm font-bold my-0 leading-snug': size == 'md',
                            'text-base font-bold my-0 leading-tight': size == 'lg',
                            'text-base font-bold my-1 leading-tight': size == 'xl',
                            'text-xl font-bold my-1 leading-tight': size == '2xl',
                        }
                    ]"
                >
                    {{ util.date.to12CycleTimeParts(block.continuation ? block.shift_start_time : block.start_time)[0] }}<span class="text-xs">{{ util.date.to12CycleTimeParts(block.continuation ? block.shift_start_time : block.start_time)[1] }}</span><br />

                    &ndash;{{ util.date.to12CycleTimeParts(util.date.timeAfterMinute(block.start_time, block.continues ? block.duration+block.continuation_duration : block.duration))[0] }}<span class="text-xs">{{ util.date.to12CycleTimeParts(util.date.timeAfterMinute(block.start_time, block.continues ? block.duration+block.continuation_duration : block.duration))[1] }}</span>
                </span>

                <div
                    v-if="props.reasons?.length > 0"
                    :class="[
                        'mt-1 w-full gap-1.5 flex flex-col items-start',
                        // { 'hidden': blockState }
                    ]"
                >
                    <div
                        v-for="(reason, index) in props.reasons"
                        :key="index"
                        class="text-xs font-semibold leading-tight break-words whitespace-normal"
                    >
                        {{ reason }}
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
